module.exports = __webpack_public_path__ + "static/media/Data_Confirmacao.66b07fa4.svg";